$(document).ready(function() {
    
    // prepend general message to header
    $('.generalmessage').prependTo('.header');

    // custom header search field functionality
    const nav = $('#mainNavigation');
    const directions = $('.standAloneDirections');
  
    function handleSearch() {
      const input = $('.customSearch__input');
      const value = input.val();
      if (value !== '') { 
        $('.searchBox .inputFieldTextbox').val(value);
        $('.searchBox .searchSubmitButton').click();
      } else {
        return false;
      }
    }
  
    $('.customSearch').on('click keypress', function(e) {
      console.log('hi')
      e.preventDefault();
      if (e.key === 'Enter' || e.type === 'click') {
        const wrapper = $('.customSearch-wrapper');
        if (!wrapper.hasClass('search-active')) {
          nav.fadeOut('fast');
          directions.fadeOut('fast');
          wrapper.fadeOut('fast', function() {
            wrapper.addClass('search-active');
            wrapper.fadeIn('fast', function() {
              $('.customSearch__input').focus();
            });
          })
        } else {
          handleSearch();
        }
      }
    });
  
    $('.customSearch__close').on('click keypress', function(e) {
      const wrapper = $('.customSearch-wrapper');
      wrapper.fadeOut('fast', function() {
        wrapper.removeClass('search-active');
        wrapper.fadeIn('fast');
        nav.fadeIn('fast');
        directions.fadeIn('fast');
      });
    });


    // remove separators from footer navigation 
    $('.footer .separator').remove();

    // change footer saffire logo img
    $('.footer .saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffireFooter-logo.png`);

});
  
